/* eslint-disable react/forbid-prop-types */
import { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import MobileSearchBar from 'shared/mobile-search-bar'
import { compose } from 'redux'
import { withContextualizedTracking, track } from 'lib/analytics'
import * as BLConstants from 'shared/constants'
import SubNav from './sub-nav'
import { getTopLevelTopicSlugFromPath } from '../lib'
import { helloBabySearchPath } from '../../lib/urls'

class App extends Component {
  componentDidMount() {
    const { router } = this.props

    // listen for other parts of our site (mobile nav) to trigger route changes
    PubSub.subscribe(BLConstants.ROUTE_CHANGE, (path) => {
      router.push(path)
    })
  }

  render() {
    const { children, location, posts, state, topicNavigation } = this.props
    const { minimalView } = this.context

    return (
      <div style={{ minHeight: 'calc(100vh)' }}>
        {!minimalView ? (
          <SubNav
            className="hidden-xs"
            searchTerm={location.query.search_term}
            topicSlug={getTopLevelTopicSlugFromPath(
              location.pathname,
              posts,
              state
            )}
            topics={topicNavigation.items}
          />
        ) : null}

        {!minimalView ? (
          <MobileSearchBar
            placeholder="Search guides"
            submitPath={helloBabySearchPath}
          />
        ) : null}

        {/* the top margin class is applied if we are not on a post (guide, article, sample registry) page */}
        {children}
      </div>
    )
  }
}

App.contextTypes = {
  minimalView: PropTypes.bool,
}

App.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object.isRequired,
  posts: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  state: PropTypes.object.isRequired,
  topicNavigation: PropTypes.object.isRequired,
}

// eslint-disable-next-line import/no-default-export
export default compose(
  withContextualizedTracking({ eventLocation: track.EventLocation.HOME_PAGE }),
  withRouter
)(App)
